import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import { translations } from '../i18n/translations';

export default class StepsNavigation extends Component{

    constructor(props){
        super(props);

        this.state = {
            activePage: 'shipment'
        }
    }

    render(){

        var { shipment_details, buyer_details, payment, print_certificate, 
            step } = translations

        return(
            <div className="clearfix steps-navigation">
                <ul className="nav nav-pills nav-justified">
                    <li>
                        <NavLink activeClassName="active" to="/buy/shipment-details">
                            <h3>{ step } 1:</h3>
                            <span>{ shipment_details }</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink activeClassName="active" to="/buy/buyer-details">
                            <h3>{ step } 2:</h3>
                            <span>{ buyer_details }</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink activeClassName="active" to="/buy/payment">
                            <h3>{ step } 3:</h3>
                            <span>{ payment }</span>
                        </NavLink>
                    </li>
                    <li>
                        <NavLink activeClassName="active" to="/buy/get-certificate">
                            <h3>{ step } 4:</h3>
                            <span>{ print_certificate }</span>
                        </NavLink>
                    </li>
                </ul>
                <div className="steps-wrap"></div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/StepsNavigation.jsx